import React from "react";

import { Options } from "@contentful/rich-text-react-renderer";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";

import CheckIcon from "../../atoms/icons/CheckIcon";

import rawToReact from "../../../utils/rawToReact";

import "./JobRecommendations.scss";

const mainClassName = "m-job-recommendations";

const headingBlockList = [
    BLOCKS.HEADING_1,
    BLOCKS.HEADING_2,
    BLOCKS.HEADING_3,
    BLOCKS.HEADING_4,
    BLOCKS.HEADING_5,
    BLOCKS.HEADING_6,
];

const renderHeadings = headingBlockList
    ?.map((type) => ({
        [type]: (_, children) => {
            return <h2 className="subtitle">{children}</h2>;
        },
    }))
    .reduce((a, b) => ({ ...a, ...b }), {});

interface JobRecommendationsProps {
    recommendation: string;
    aboutUs: string;
    onClickPostulate: () => void;
}

const JobRecommendations = ({
    aboutUs,
    recommendation,
    onClickPostulate,
}: JobRecommendationsProps) => {

    const contentfulRenderOptions: Options = {
        renderNode: {
            [INLINES.HYPERLINK]: ({ data }, children) => (
                <a
                    href={data.uri}
                    target={"_blank"}
                    rel={"noopener noreferrer"}
                    style={{ color: "var(--color-magenta-white)" }}
                    className="m-job-recommendations__link"
                >
                    {children}
                </a>
            ),
            [BLOCKS.UL_LIST]: (_, children) => {
                return (
                    <ul className="tips-list">
                        <li className="tips-list__item">
                            <CheckIcon />
                            <span>
                                Haz clic en{" "}
                                <span
                                    onClick={onClickPostulate}
                                    role="button"
                                    rel="noopener noreferrer"
                                    className="m-job-recommendations__btn-link"
                                >
                                    Postularme
                                </span>
                            </span>
                        </li>
                        {children}
                    </ul>
                );
            },
            [BLOCKS.LIST_ITEM]: (_, children) => {
                return (
                    <li className="tips-list__item">
                        <CheckIcon />
                        <span>{children}</span>
                    </li>
                );
            },
            ...renderHeadings,
        },
        renderText: (text) =>
            text.split("\n").flatMap((text, i) => [i > 0 && <br />, text]),
    };

    return (
        <section className={mainClassName}>
            <div className={`${mainClassName}__recommendations-card`}>
                <h2 className="subtitle">Recomendaciones</h2>
                <div className={`${mainClassName}__tips`}>
                    {recommendation &&
                        rawToReact(recommendation, contentfulRenderOptions)}
                </div>
            </div>

            <div className={`${mainClassName}__about-us-card`}>
                {/* <h2 className="subtitle">Sobre nosotros</h2> */}
                <div>
                    {aboutUs && rawToReact(aboutUs, contentfulRenderOptions)}
                </div>
            </div>
        </section>
    );
};

export default JobRecommendations;
